import { render, staticRenderFns } from "./DentalServices.vue?vue&type=template&id=4712f765&scoped=true"
import script from "./DentalServices.vue?vue&type=script&lang=js"
export * from "./DentalServices.vue?vue&type=script&lang=js"
import style0 from "./DentalServices.vue?vue&type=style&index=0&id=4712f765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712f765",
  null
  
)

export default component.exports